import { AutogenModelPnnControl, AutogenRowPnnControl } from "./autogen/AutogenModelPnnControl";

export class ModelPnnControl extends AutogenModelPnnControl<RowPnnControl> {
	constructor() {
		super(RowPnnControl);
	}
}

export class RowPnnControl extends AutogenRowPnnControl {
}